import styled from 'styled-components'

export const Wrapper = styled.section`
  .tsparticles-canvas-el {
    pointer-events: none !important;
  }
`
